import { connect } from 'react-redux';
import TasksDetails from '../../../../components/tasks/details/TasksDetails';
import {
  taskBarcodeUrl,
  taskCarouselImages,
  loadingImages,
  loadingTasksStatus,
  tasksStatusList,
  progressTasksType,
  resourcesTasksType,
  placementInformation,
  categoriesList,
  currentStore,
  currentTaskType,
} from 'core/selectors';
import { getImages } from 'core/slices/images';
import { getTaskList, clearTaskList, loadTaskList, getTasksProgress } from 'core/slices/tasks';
import { updateTasks } from 'core/slices/tasks_modification';
import { getAislesByTasks } from 'core/slices/aisles';

export default connect(
  (state) => ({
    carouselImages: taskCarouselImages(state),
    barcodeUrl: taskBarcodeUrl(state),
    loadingImages: loadingImages(state),
    loadingTasksStatus: loadingTasksStatus(state),
    tasksStatus: tasksStatusList(state),
    progressTasksType: progressTasksType(state),
    resourcesTasksType: resourcesTasksType(state),
    placementInformation: placementInformation(state),
    categories: categoriesList(state),
    currentStore: currentStore(state),
    currentTaskType: currentTaskType(state),
  }),
  {
    getImages,
    updateTasks,
    clearTaskList,
    loadTaskList,
    getTaskList,
    getTasksProgress,
    getAislesByTasks,
  },
)(TasksDetails);
